import React, { useState, useContext } from "react";
import { Container, Title, Header, Body, Item, Inner } from "./style/accordian";

const ToggleContext = React.createContext();

export default function Accordion({children, ...restProps}){
    return <Container {...restProps}>
                <Inner>
                    {children}
                </Inner>
            </Container>
}

Accordion.Item = function AccordionItem({children, ...restProps}){
    const [toggleShow, setToggleShow] = useState(false);
    return (
        <ToggleContext.Provider value={{toggleShow, setToggleShow}}>
            <Item {...restProps}>{children}</Item>
        </ToggleContext.Provider>
    )
        
}

Accordion.Title = function AccordionTitle({children, ...restProps}){
    return <Title {...restProps}>{children}</Title>
}

Accordion.Header = function AccordionHeader({ children, ...restProps}){
    const { toggleShow, setToggleShow} = useContext(ToggleContext);
    return <Header onClick={()=> setToggleShow(!toggleShow)} {...restProps}>
                {children}
                { toggleShow ? <img  src="./images/icons/close-slim.png" alt="close" /> 
                    : <img src="./images/icons/add.png" alt="open" />
                }
            </Header>
}

Accordion.Body = function AccordionBody({children, ...restProps}){
    const { toggleShow } = useContext(ToggleContext);
    return toggleShow ? (<Body {...restProps}>
            {children}
        </Body>) : null;
}
